import business from "moment-business";
import moment from "moment";

//Mes e dia de todos os feriados nacionais do Brasil
const feriadosNacionais = ["01-01", "04-10", "04-21", 
"05-01", "09-07", "10-12", "11-02", "11-15", "12-25"]

/**
 * @param {String} dataAtual: Data complete neste formato ano-mes-dia.
 * @param {String} anoCompleto: Ano selecionado.
 * @param {Int} contagem: Quantos dias terei que somar para frente.
 */
const contarDias = (dataAtual, anoCompleto, contagem) => {
    const contar = parseInt(contagem);
    let capturarFeriado = 0;
    const separarData = dataAtual.split("-");

    //Converter dia mes e ano de string para inteiro
    let selecionarAno = parseInt(separarData[0]);
    let selecionarMes = parseInt(separarData[1]);
    let somarDia = parseInt(separarData[2]);

    for(let c = 1; c <= contar; c++){
        somarDia ++;
        
        if(separarData[1] === "02" && somarDia === 28){
            somarDia = 1;
        }else if(somarDia === 31){
            somarDia = 1;
            selecionarMes += 1;
            if(selecionarMes > 12){
                selecionarMes = 1;
                selecionarAno + 1;
            }
        }

        const zeroNoMes = AdicionarZeroNoDiaOuNoMes(selecionarMes);
        const zeroNoDia = AdicionarZeroNoDiaOuNoMes(somarDia);
        const formatarData = `${selecionarAno}-${zeroNoMes}${selecionarMes}-${zeroNoDia}${somarDia}`;
        feriadosNacionais.map(item => {

            //Formatar a data para os feriados Ex: 2020-11-15 
            const DataDeFeriado = `${anoCompleto}-${item}`;

            //Verifica se a data passada é um feriado
            if(formatarData === DataDeFeriado){
                const dataMoment = moment(formatarData);

                //Verifica se o feriado é final de semana
                const ehFinalDeSemana = business.isWeekendDay(dataMoment);

                //Caso sim, vai retornar 0(zero), porque final de semana não é dia util
                if(ehFinalDeSemana === true){
                    capturarFeriado = 0;
                }else{
                    capturarFeriado ++;
                }
            }
        });
    }
    return capturarFeriado;
}

/**
 * @param {String} dataAtual Data copleta neste formato ano-mes-dia
 * @param {Int} contagem Quanto dias para frente terei que somar
 */
export const feriados = (dataAtual, contagem) => {
    const ano = new Date();
    const anoCompleto = ano.getFullYear();
    return contarDias(dataAtual, anoCompleto, contagem);
}

/**
 * Função para realizar a verificação se o dia ou o mês é menor que 9, se for menor
 * vai retornar uma string com o numero 0, se for maior que 9 vai retorna uma string vazia. 
 * @param {String} date: 
 */
const AdicionarZeroNoDiaOuNoMes = (date) => date <= 9 ? "0" : "";

//Fazer a soma de um mes especifivo
const SomarMes = (mes) => {
    parseInt(mes);
    if(!mes <= 11){
        return mes += 1
    }
    return mes
}

/**
 * Função para Instanciar a classe Data, de acordo com a data selecionada
 * 
 * @param {String} selecionar 
 */
const selecionarData = (selecionar) => {
    let data = new Date();
    if(!selecionar == ""){
        return new Date(selecionar); 
    }
    return data;
}

/**
 *  Exemplo:   
 * 
 * DataCompleta: retorna a data completa 99/09/9999
 * 
 * MesAno: retorna o mes e o ano 09/9999
 * 
 * Ano:  retorna o ano com 4 digitos
 * 
 * @param {String} tipo: O tipo de data que voce deseja ter
 * @param {String} seleciona: data completa com dia mes e ano
 */
export const novaData = (tipo, seleciona) => {

    const date = selecionarData(seleciona);

    const mapa = new Map();

    mapa.set("DataCompleta", dataCompleta(date));
    mapa.set("MesAno", MesAno(date));
    mapa.set("Ano", Ano(date));
    return mapa.get(tipo);
};

//Função para retornar a data completa para o usuario
const dataCompleta = (data) => {
    const dia = AdicionarZeroNoDiaOuNoMes(data.getDate());
    
    //Como a contagem dos meses inicia-se com 0, aqui fazemos uma soma para o mes correto
    const somaMes = SomarMes(data.getMonth());
    
    const mes = AdicionarZeroNoDiaOuNoMes(somaMes);

    //Formata o mes, adicionando o zero se o numero for menor que 9
    const formatarMes = `${mes}${somaMes}`;

    //Formata o dia corrreto, adicionando um Zero se o dia for menor que nove
    const formatarDia = `${dia}${data.getDate()}`;

    const diaMesAno = `${formatarDia}/${formatarMes}/${data.getFullYear()}`;
    return diaMesAno;
}

//Função para retornar o mes e o ano
const MesAno = (date) => {
    const somaMes = SomarMes(date.getMonth());
    const mes = AdicionarZeroNoDiaOuNoMes(somaMes);
    const mesAno = `${mes}${somaMes}/${date.getFullYear()}`;
    return mesAno;
}

//Essa função só retorna o ano especifico
const Ano = (date) => date.getFullYear();

/**
 * Converte a data dentro de uma string de log de UTC para o fuso horário de São Paulo.
 * @param {string} logString - A string de log completa. Ex: '10/12/2025 17:30:07 - Mensagem do log.'
 * @returns {string} A string de log com a data convertida.
 */
export const converterLogParaHorarioDeSaoPaulo = (logString) => {
  if (!logString || typeof logString !== 'string') {
    return "";
  }

  const partes = logString.split(' - ');
  const dataHoraUTC = partes.shift().trim();
  const mensagem = partes.join(' - ');

  const dataConvertida = moment.utc(dataHoraUTC, 'DD/MM/YYYY HH:mm:ss').subtract(3, 'hours').format('DD/MM/YYYY HH:mm:ss');

  return `${dataConvertida} - ${mensagem}`;
};
